module.exports = __webpack_public_path__ + "static/media/plantbased.290e1629.jpg";